<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99987 10.0691C9.14253 10.0691 10.0688 9.14278 10.0688 8.00012C10.0688 6.85746 9.14253 5.93115 7.99987 5.93115C6.85722 5.93115 5.93091 6.85746 5.93091 8.00012C5.93091 9.14278 6.85722 10.0691 7.99987 10.0691Z"
      fill="white"
    />
    <path
      d="M11.2974 0.5H4.70259C2.38147 0.5 0.5 2.38147 0.5 4.70259V11.2974C0.5 13.6185 2.38147 15.4935 4.70259 15.5H11.2974C13.6185 15.5 15.4935 13.6185 15.5 11.2974V4.70259C15.5 2.38147 13.6185 0.5 11.2974 0.5ZM8 11.6013C6.00862 11.6013 4.39871 9.99138 4.39871 8C4.39871 6.00862 6.00862 4.39871 8 4.39871C9.99138 4.39871 11.6013 6.00862 11.6013 8C11.5948 9.98491 9.98491 11.5948 8 11.6013ZM11.8987 5C11.4009 5 11 4.59914 11 4.10129C11 3.60345 11.4009 3.20259 11.8987 3.20259C12.3966 3.20259 12.7974 3.60345 12.7974 4.10129C12.7974 4.59914 12.3966 5 11.8987 5Z"
      fill="white"
    />
  </svg>
</template>
  
<script>
export default {
  name: "InstagramWhiteIcon",
};
</script>